import React from 'react';
import { useTracking } from 'react-tracking';
import globalStyles from 'theme/globalStyles';
import { useAuth } from 'context/AuthContext/AuthContext';
import { initTracking, track } from 'utils/tracking';
import AuthenticatedApp from 'AuthenticatedApp';
import UnauthenticatedApp from 'UnauthenticatedApp';
import { FeaturesProvider } from 'context/FeaturesContext/FeaturesContext';
import { groupsFromAccess } from 'utils/apiUser';

initTracking();

function App() {
  const { tokens } = useAuth();
  const { Track } = useTracking({}, { dispatch: track });
  globalStyles();

  return (
    <Track>
      <FeaturesProvider
        groups={tokens ? groupsFromAccess(tokens.access_token) : undefined}
      >
        {tokens ? <AuthenticatedApp /> : <UnauthenticatedApp />}
      </FeaturesProvider>
    </Track>
  );
}

export default App;
